export enum LoadingState {
  IDLE = 'idle',
  LOADING = 'loading',
  READY = 'ready',
}
